<template>
  <div class="transh-box-main">
    <layouts>
      <template v-slot:sidebar>
        <sidebar/>
      </template>

      <template v-slot:content>
        <div class="trash-main">
          <div class="title" v-if="data.length">
            <i class="iconfont iconcuowu" style="color: #ff4f4f;margin-left: 20px;margin-right: 6px;"></i>
            <b>提示：</b>
            <span>回收站内保存最近 <span style="color: rgb(255,0,0)">{{(personInfo.is_membership&&(personInfo.membership_expired_at.substr(0, 4) > '2100'))?360:30}}</span> 天内删除的 10 份简历，清空后将无法恢复，请谨慎操作！</span>
            <button @click="deleteCvAll" :class="[data.length ? 'action' : '']">清空回收站</button>
          </div>
          <div v-if="data.length">
            <div class="menu" v-for="item in data" :key="item.token">
              <div class="picture">
                <img src="@/assets/image/grayIcon.png" alt="">
              </div>
              <div class="info">
                <div class="name">{{item.display_name || "未命名超级简历"}}</div>
                <div class="label">
                  <p v-if="item.short_lang">{{item.short_lang}}</p>
                  <p v-if="item.score">简历评分：{{ item.score === null ? 40 : item.score }}分</p>
                  <p v-if="item.type_name">{{item.type_name}}</p>
                </div>
                <div class="operate">
                  <div class="date">最后编辑：{{item.updated_at | timeFormatFilter}}</div>
                  <div class="btn">
                    <button @click="recoveryCv(item.token)">
                      <img class="img" src="@/assets/image/resume1.png" alt="">
                      <img class="img-hover" src="@/assets/image/resume2.png" alt="">
                      <span>恢复文件</span>
                    </button>
                    <button @click="deleteCv(item.token, item.display_name)">
                      <img class="img" src="@/assets/image/delete1.png" alt="">
                      <img class="img-hover" src="@/assets/image/delete2.png" alt="">
                      <span>彻底删除</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <default-page class="default-page" v-if="!data.length && !isRequest">暂无已删除简历</default-page>
        </div>
      </template>
    </layouts>

    <trash-alert :show="alertBox.show" :title="alertBox.title" :button-name="alertBox.buttonName"
                 :content="alertBox.content" @confirm="alertBox.confirm" @close="alertBox.show = false"
                 :hide-close-btn="alertBox.hideCloseBtn"/>
  </div>
</template>
<script>
  import layouts from '@/components/base/layouts';
  import sidebar from '@/components/base/sidebar';
  import trashAlert from '@/components/trashAlert';
  import defaultPage from '@/components/base/default';
  import api from '@/api';
  import {
    dealSignatrue,
    auth,
    routerTo
  } from '@/assets/js/util';
  import {mapState} from "vuex"

  export default {
    name: 'trash_cvs',
    components: {
      layouts,
      sidebar,
      trashAlert,
      defaultPage
    },
    computed: {
      ...mapState("me", ['personInfo'])
    },
    data() {
      return {
        isRequest: false,
        data: [],
        total: 0,
        pageQuery: {
          page_size: 10,
          page: 1
        },
        alertBox: {
          show: false,
          title: '清空回收站',
          content: '',
          buttonName: '确定',
          confirm: () => {
          }
        },
        isSup: false
      };
    },
    created() {
      console.log(this.personInfo)
      this.$store.dispatch('app/setNavbarAction', '我的简历');
      this.$store.dispatch('app/setSidebar', '回收站');
      this.isRequest = true;
      this.getList();
    },
    methods: {
      async getList() {
        // let params = await dealSignatrue({
        //   ...this.pageQuery
        // });
        await api.trash.getDeletedList(this.$axios, this.pageQuery).then(res => {
          this.$store.dispatch('app/hasCoverletter', res.data.has_coverletter);
          this.isRequest = false;
          this.data = res.data.cvs || [];
          this.total = res.data.total_count || 0;
        }).catch(err => {
          this.isRequest = false;
        })
      },
      async recoveryCv(token) {
        let params = {
          operation_type: 'recovery'
        };
        await api.trash.recoveryCv(this.$axios, params, token)
          .then(res => {
            console.log(res)
            if (res.code === 1000) {
              this.$message.success('简历恢复成功');
              this.getList();
            } else if (res.code === 3000) {
              this.alertBox = {
                show: true,
                title: '恢复文件提示',
                content: '简历数量已达上限，需删除其他简历才能恢复该简历。',
                buttonName: '知道了',
                hideCloseBtn: true,
                confirm: () => {
                  this.alertBox = {};
                }
              };
            } else if (res.code === 3001) {
              this.alertBox = {
                show: true,
                title: '恢复文件提示',
                content: '当前有效简历已达上限，开通会员即可恢复更多简历！',
                buttonName: '开通会员',
                confirm: async () => {
                  // let params = await dealSignatrue({
                  //   client: process.env.CLIENT
                  // });
                  // await api.me.orderCreateByMembership(params)
                  //   .then(res => {
                  //     if (res.status === 1) {
                  //       routerTo('/orders/' + res.data.order_token);
                  //     }
                  //   })
                  routerTo('/account/users/buy_member')
                }
              };
            }
          }).catch(err => {
            this.$message.error('服务器打盹了...');
          })
      },
      deleteCv(token, cvName) {
        let run = false;
        this.alertBox = {
          show: true,
          buttonName: '删除',
          title: '彻底删除简历',
          content: '即将彻底删除 1 个简历。删除后将无法恢复，请谨慎操作！',
          confirm: async () => {
            clearTimeout(run)
            run = setTimeout(async () => {
              let params = {};
              api.trash.deleteCv(this.$axios, params, token)
                .then(res => {
                  this.$set(this.alertBox, 'show', false);
                  if (res.code === 1000) {
                    this.$message.success('简历删除成功');
                    this.getList();
                  } else {
                    this.$message.error('简历删除失败');
                  }
                })
                .catch(err => {
                  this.$message.error('服务器打盹了...');
                })
            }, 300);
          }
        };
      },
      deleteCvAll() {
        if (!this.data.length) {
          return false;
        }
        if (this.isDeleteAll) return false;

        let run = false;
        this.alertBox = {
          show: true,
          buttonName: '确定清空',
          title: '清空回收站',
          content: `即将清空回收站。清空后将无法恢复，请谨慎操作！`,
          confirm: async () => {
            clearTimeout(run);
            run = setTimeout(async () => {
              this.isDeleteAll = true;
              let loading = this.$message({
                iconClass: 'el-icon-loading',
                duration: 0,
                message: '正在清空'
              })
              let params = await dealSignatrue();
              api.trash.emptyDeletedCvs(this.$axios, params)
                .then(res => {
                  this.$set(this.alertBox, 'show', false);
                  this.isDeleteAll = false;
                  loading.close();
                  if (res.code === 1000) {
                    this.$message.success('简历清空成功');
                    this.getList();
                  } else {
                    this.$message.error('简历清空失败');
                  }
                }).catch(err => {
                this.isDeleteAll = false;
                loading.close();
                this.$message.error('服务器打盹了...');
              })
            }, 300);
          }
        };
      },
      prev() {
        this.pageQuery.page--;
        this.getList();
      },
      next() {
        this.pageQuery.page++;
        this.getList();
      },
      currentChange(page) {
        this.pageQuery.page = page;
        this.getList();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .default-page {
    background: #fff;
  }

  .transh-box-main {
    margin-bottom: 60px;
    min-height: 649px;
    /*margin-top: 80px;*/
  }

  .trash-main {
    width: 900px;
    border-radius: 4px;
    overflow: hidden;

    & > div {
      margin-bottom: 1px;
      // background: #fff;
    }

    .title {
      height: 56px;
      position: relative;
      display: flex;
      align-items: center;
      color: #404040;
      font-size: 14px;
      background: #fff;

      img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
        margin-left: 20px;
      }

      b {
        color: #FF4F4C;
        font-weight: 400;
      }

      button {
        width: 102px;
        height: 32px;
        border-radius: 2px;
        background: #C4C4C4;
        color: #fff;
        font-size: 14px;
        position: absolute;
        top: 12px;
        right: 24px;
        cursor: no-drop;

        &.action {
          cursor: pointer;
          background: #50A4FF;
        }
      }
    }

    .menu {
      width: 100%;
      height: 170px;
      display: flex;
      background: #fff;
      margin-bottom: 1px;

      .picture {
        width: 120px;
        height: 120px;
        border-radius: 6px;
        border: 1px solid #DEDFE1;
        margin: 25px 24px 0;

        img {
          width: 40px;
          height: 48px;
          margin: 36px auto 0;
        }
      }

      .info {
        height: 120px;
        width: 692px;
        margin-top: 25px;
        position: relative;

        .label {
          display: flex;
          align-items: center;
          margin-top: 14px;

          & > p {
            height: 24px;
            line-height: 24px;
            background: #F1F2F6;
            border-radius: 2px;
            padding: 0 12px;
            margin-right: 12px;
            color: #404040;
            font-size: 13px;
          }
        }

        .operate {
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .date {
            color: #9C9C9C;
          }

          .btn {
            display: flex;
            align-items: center;

            button {
              display: flex;
              align-items: center;
              justify-content: center;
              color: #404040;
              margin-left: 38px;
              padding: 0;
              background: transparent;

              img {
                width: 22px;
                margin-right: 4px;
              }

              .img-hover {
                display: none;
              }

              &:hover {
                color: #FF4F4C;

                .img {
                  display: none;
                }

                .img-hover {
                  display: block;
                }
              }
            }
          }
        }
      }

      &:hover {
        position: relative;
        box-shadow: 0 0 20px #ddd;
        z-index: 3;
      }
    }
  }
</style>
